
export const parseApiResponse = async (response: Response) => {
  if (response !== undefined) {
    const text = await response.text();
    let resp = text ? JSON.parse(text) : {};
    if (!resp.status) {
      return resp.message;
    } else {
      return resp;
    }
  } else {
    throw new Error("Response is Required");
  }
};

export const parseApiResponseJSON = async (response: {
  text: () => Promise<any>;
}) => {
  if (response !== undefined) {
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  } else {
    throw new Error("Response is Required");
  }
};
